import GalleryPage from "@/components/GalleryPage";

const BIRDPOT_VIDEO = "https://customer-assets.emergentagent.com/job_green-creations/artifacts/s5jkr4h1_Birdpot%20Animation.mp4";

const items = [
  {
    title: "Yellow Teapot Birdpot",
    desc: "Charming 2-cup detached residence with south-facing spout balcony, oak-panelled entrance, and uninterrupted garden views. Ideal for the discerning wren.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/sgaepqdu_IMG_6081.JPG",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Rose Teapot Birdpot",
    desc: "Elegant period property with floral ceramic facade and reclaimed hardwood backing. Generous entrance hole. Would suit a robin with refined taste.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/w0odk5u5_IMG_6088.JPG",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Tartan Floral Birdpot",
    desc: "Rare Scottish-inspired 3-cup residence with tartan banding and oak feature wall. Handle perch included. No chain.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/gd4qnptr_IMG_6060.JPG",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Garden Bloom Birdpot",
    desc: "Spacious family home with hand-painted floral exterior and walnut-panelled rear. Wraparound ivy. Open-plan spout with a view. Viewing highly recommended.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/ywuoviaj_IMG_6071.JPG",
    span: "md:col-span-6",
    height: "h-80 md:h-[28rem]",
    contain: true,
  },
  {
    title: "Pink Tulip Birdpot",
    desc: "Bijou cottage with rose accents, pine feature backing, and a delightful spout terrace perfect for morning worms. Must be seen to be appreciated.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/4fimrfyi_IMG_6122.JPG",
    span: "md:col-span-6",
    height: "h-80 md:h-[28rem]",
    contain: true,
  },
  {
    title: "Lace Pattern Birdpot",
    desc: "Unique drum-style penthouse with intricate lace detailing and oak rear elevation. Compact yet distinguished. Ideal pied-a-terre for the modern blue tit.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/xsy6dbgj_IMG_6143.JPG",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Blue Vine Birdpot",
    desc: "Characterful 2-cup cottage with crackling glaze finish and climbing vine motif. Oak-backed. South-facing spout. Quiet cul-de-hedge location.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/dbrtdkxu_WhatsApp%20Image%202026-04-15%20at%2018.03.23%20%285%29.jpeg",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Cobalt Blue Birdpot",
    desc: "Striking cobalt-glazed residence on premium walnut backing. Bold exterior, cosy interior. Spout balcony with 180-degree garden panorama. Guide price: 3 worms.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/bb8z0c1t_IMG_6068.JPG",
    span: "md:col-span-4",
    height: "h-80 md:h-[26rem]",
    contain: true,
  },
  {
    title: "Blue Lotus Birdpot",
    desc: "Exquisite 2-cup semi with hand-painted lotus motif and walnut feature wall. Rose garden frontage. En-suite spout. Chain free — ready to nest immediately.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/g9y51x6s_IMG_6106.JPG",
    span: "md:col-span-6",
    height: "h-80 md:h-[28rem]",
    contain: true,
  },
  {
    title: "Mint Drum Birdpot",
    desc: "Contemporary drum-style residence in eye-catching turquoise. Oak rear. Circular entrance with excellent feng shui. Would suit a trendy sparrow or style-conscious finch.",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/hb2iaxm1_IMG_6133.JPG",
    span: "md:col-span-6",
    height: "h-80 md:h-[28rem]",
    contain: true,
  },
];

export default function Birdpots() {
  return (
    <GalleryPage
      testId="birdpots-page"
      title="Birdpots"
      subtitle="Half birdhouse, half planter, 100% made from stuff other people threw away. Your garden birds deserve better than a plastic box from B&Q."
      items={items}
      videoSrc={BIRDPOT_VIDEO}
      videoCaption="Watch the magic happen"
      imageFilter="brightness-105 contrast-105 saturate-[1.15]"
    />
  );
}
